import { post, handleClientError } from '../lib'

export interface NotificationResponse {
  newNotifications: NewNotifications[] | []
  numOfUnreadNotifications: number
}

interface NewNotifications {
  id: number | string
  message: string
  dateCreated: string
  what: null | string
  viewed: boolean
  user: {
    id: number
  }
  isNew: boolean
  whatId: number
  subject: string
}

export const postNotifications = async (
  unreadNotificationCounter: number,
  highestNewNotificationId: number
): Promise<NotificationResponse | null> => {
  try {
    const res = await post<null, NotificationResponse>({
      path: `/api/v1/notifications/checkForNewAndUnread`,
      query: {
        highestNewNotificationId,
        unreadNotificationCounter
      },
      body: null
    })

    if (!res || typeof res !== 'object') {
      return null
    } else {
      return {
        newNotifications: res.newNotifications || [],
        numOfUnreadNotifications: res.numOfUnreadNotifications || 0
      }
    }
  } catch (e: any) {
    throw handleClientError(e)
  }
}

export const postMarkOldNotifications = async (
  highestNewNotificationId: number
): Promise<string> => {
  if (!highestNewNotificationId) return ''

  return post<null, string>({
    path: `/api/v1/notifications/checkForNewAndUnread`,
    query: {
      notifications: highestNewNotificationId
    },
    body: null
  })
}
